import { Box, IconButton, makeStyles } from "@material-ui/core";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import clsx from "clsx";
import { FC, useContext } from "react";

import TooltipPopover from "../../../../../components/TooltipPopover";
import { ILocalFileEntry } from "../types";
import { ImageUploaderContext } from "./ImageUploaderContainer";

const useStyles = makeStyles(() => ({
  item: {
    width: 100,
    height: 100,
    margin: 4,
    overflow: "hidden",
    position: "relative",

    "&.has-error": {
      border: "3px solid red",
      opacity: 0.5,
    },
  },
}));

const ImageUploaderPreviewItem: FC<ImageUploaderItemProp> = ({ entry }) => {
  const classes = useStyles({});
  const { onRemoveFile, maximumImageSize } = useContext(ImageUploaderContext);

  const isValidImageSize = (entry: ILocalFileEntry) => entry.file.size <= maximumImageSize * 1e6;
  const isValidImageType = (entry: ILocalFileEntry) => entry.file.type.startsWith("image/");

  const renderErrorMessage = (entry: ILocalFileEntry) => {
    return !isValidImageType(entry)
      ? "Only accept images"
      : !isValidImageSize(entry)
      ? `Maximum image size is ${maximumImageSize}MB`
      : undefined;
  };

  return (
    <TooltipPopover message={renderErrorMessage(entry)}>
      <Box className={clsx([classes.item, { "has-error": !isValidImageSize(entry) || !isValidImageType(entry) }])}>
        <Box position="absolute" top={5} right={5}>
          <IconButton onClick={() => onRemoveFile?.(entry)} size="small">
            <HighlightOffIcon fontSize="small" color="error" />
          </IconButton>
        </Box>
        <img
          src={entry.localUrl}
          alt={entry.localUrl}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      </Box>
    </TooltipPopover>
  );
};

interface ImageUploaderItemProp {
  entry: ILocalFileEntry;
}

export default ImageUploaderPreviewItem;
